import * as signalREventNamesEnum from '~/enums/signalr-event-names'

export const eventName = signalREventNamesEnum.values.OrderPlaced

export function handler(_, { store }) {
  store.dispatch('trader/loadKeyFigures')
}
